import { LoadState } from "../../constants/enums";

export interface ICSIOState {
  list: ICSIORaw[];
  loading: LoadState;
  totalRecords: number;
  rawData: ICSIORaw;
  rawDataLoading: LoadState;
  error: string | null;
  csioLogs: {
    list: ICSIOPolicyMappingLogs[];
    loading: LoadState;
    totalRecords: number;
  }
}

export interface ICSIOPolicyMappingLogs {
  create_ts: string;
created_by_id: string;
csio_log_code: string;
customer_policy_id: string;
execution_type: string;
mapping_error: string;
mapping_status: string;
message_guid: string;
modified_by_id: string;
policy_number: string;
process_name: string;
status: string;
}



export interface ICSIO {
  MessageGUID: string;
  FromEmailAddress: string;
  MessageType: string;
  MessageSubject: string;
  DateTime: string;
  CreatedDate: string;
  MessageSize: string;
}

export const initialCSIOState: ICSIOState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  rawData: {
    attachment: "",
    create_ts: "",
    created_by_id: "",
    from_email_address: "",
    is_map: 0,
    message_guid: "",
    message_subject: "",
    message_type: "",
    status: "ACTIVE",
    xml_json_message: "",
    xml_message: "",
    edi_message: "",
    policy_number: "",
   
  },
  rawDataLoading: LoadState.NotLoaded,
  error: null,
  csioLogs: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
  },
};

export interface ICSIORaw {
  message_guid: string;
  from_email_address: string;
  message_type: string;
  message_subject: string;
  attachment: string;
  is_map: number;
  xml_message: string;
  edi_message: string;
  policy_number: string;
  xml_json_message: any;
  status: string;
  created_by_id: string;
  create_ts: string;
}
